import { render, staticRenderFns } from "./WorkplaceSafety.vue?vue&type=template&id=60d8cc7a&scoped=true"
import script from "./WorkplaceSafety.vue?vue&type=script&lang=js"
export * from "./WorkplaceSafety.vue?vue&type=script&lang=js"
import style0 from "./WorkplaceSafety.vue?vue&type=style&index=0&id=60d8cc7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d8cc7a",
  null
  
)

export default component.exports